import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const login = ({ username, password }) =>
  Manager.client().post(Endpoints.auth.login, { username, password });

export const Request = {
  login,
};
